@if (card().card === 'state') {
  <ng-container *hasPermission="['READ', 'device']">
    <div class="widget-content-height">
      @if ($serviceTree() && $devicesMap()) {
        <park-kpi
          [isEdit]="isEdit"
          (updateTimeSelected)="changeTime($event)"
          (statusClick)="displayParkStatus($event)" />

        <ng-container *ngTemplateOutlet="selectServiceTemplate" />
      } @else {
        <widget-loader />
      }
    </div>
  </ng-container>

  @if (
    !permissionService.checkPermissionValue({
      permission: 'READ',
      tab: 'device',
    })
  ) {
    <p class="not-allowed-text">
      {{ 'USER.NOT_ACCESS_DATA' | translate }}
      <br />
      {{ 'USER.PLEASECONTACTADMIN' | translate }}
    </p>
  }
}

@if (card().card === 'maintenance-state') {
  <div class="aside_title-section">
    @if (!unitSelected()?.label || uid_service() === 0) {
      <h1 class="title-dashboard">
        {{ 'STATE.GLOBALMAINT' | translate }}
      </h1>
    } @else if (unitSelected()?.label && uid_service() !== 0) {
      <h1 class="title-dashboard">
        {{ 'STATE.STATUSMAINT' | translate: { value: unitSelected().label } }}
      </h1>
    }
  </div>
  <ng-container *hasPermission="['READ', 'maintenance']">
    <div class="widget-content-height container-content">
      @if (filterMaintenances$ | async; as data) {
        <app-maintenance-chart [mode]="'widget'" [maintenanceListProvided]="data"></app-maintenance-chart>
        <ng-container *ngTemplateOutlet="selectServiceTemplate"></ng-container>
      } @else {
        <widget-loader />
      }
    </div>
  </ng-container>

  @if (
    !permissionService.checkPermissionValue({
      permission: 'READ',
      tab: 'maintenance',
    })
  ) {
    <p class="not-allowed-text">
      {{ 'USER.NOT_ACCESS_DATA' | translate }}
      <br />
      {{ 'USER.PLEASECONTACTADMIN' | translate }}
    </p>
  }
}

<ng-template #selectServiceTemplate>
  @if (isEdit) {
    <div class="container-input">
      <div class="container-input-service">
        <span class="label-select-service">Service</span>
        <div [id]="card().card" (click)="selectService()" class="input-outline-service">
          <p>
            {{
              unitSelected()?.label && uid_service() !== 0
                ? unitSelected()?.label
                : ('CHART.GLOBAL_FLEET' | translate)
            }}
          </p>
          <mat-icon>
            {{ changingService ? 'arrow_drop_up' : 'arrow_drop_down' }}
          </mat-icon>
        </div>
        @if (changingService) {
          <div class="container-services">
            <tree
              (selectedCheckbox)="changeParent($event)"
              [displaySelected]="false"
              [closable]="false"
              [selected]="[uid_service()]"
              [element]="'service'"
              selectionType="radio"
              [elementSelectedType]="'node'"
              [rootItem]="true"
              [labelSearch]="'TREE.SEARCH_SERVICE'"
              [maxHeight]="200"
              [labelRoot]="'CHART.GLOBAL_FLEET'" />
          </div>
        }
      </div>
    </div>
  }
</ng-template>
